import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import TextForm from './JurisprudenciaForm';
import { TextFormValues, InitialTextForm } from '../../types/Text.types';
import { jurisprudenciaService, textService } from '../../api/services';
import { getFormattedInitialData } from './utils';
import { showToast } from '../../components/Toast/showToast';
import { InitialJurisprudenciaForm, JurisprudenciaFormValues } from '../../types/Jurisprudencia.types';
import JurisprudenciaForm from './JurisprudenciaForm';

const UpdateViewJurisprudencias = () => {
  const { id } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [initialData, setInitialData] = useState<InitialJurisprudenciaForm>({
    idJurisprudencia: undefined,
    nome: '',
    tribunal: '',
    orgao: '',
    tipoDecisao: '',
    dataPublicacao: undefined,
    assunto: '',
    area: '',
    valorTexto: '',
    enderecoArquivo: '',
  });

  const navigate = useNavigate();
  const navigateToListTexts = useCallback(() => {
    navigate('/jurisprudencias');
  }, []);

  const { pathname } = useLocation();
  const type = pathname.includes('update') ? 'update' : 'view';

  useEffect(() => {
    async function getInitialData() {
      const jurisprudenciaData = await jurisprudenciaService.getById(id as string);
      console.log(getFormattedInitialData(jurisprudenciaData));
      setInitialData(getFormattedInitialData(jurisprudenciaData));
      setIsLoading(false);
    }

    getInitialData();
  }, []);

  const handleSubmit = useCallback(async (data: JurisprudenciaFormValues) => {
    const successfullyUpdated = await jurisprudenciaService.update(id as string, data);
    if (successfullyUpdated) {
      showToast({
        type: 'success',
        text: 'Sucesso ao atualizar jurisprudencia.',
      });
      navigateToListTexts();
    }
  }, []);

  return !isLoading ? (
    <>
      <JurisprudenciaForm
        type={type}
        initialData={initialData}
        onSubmit={handleSubmit}
        onCancel={navigateToListTexts}
      />
    </>
  ) : null;
};

export default UpdateViewJurisprudencias;
